import request from '@/utils/request'

// 文件上传返回url
export function uploadFile(data) {
  return request({
    url:'/product/file/upload',
    method:'post',
    data
  })
}

// 上传完成预览
export function previewUpload(fileName) {
  return request({
    url:'/product/file/previewUpload',
    method:'get',
    params: {fileName}
  })
}

// 图片/视频预览
export function previewFile(fileName) {
    return request({
      url:`/product/file/preview`,
      method:'get',
      params: {fileName}
    })
  }






// WEBPACK FOOTER //
// ./src/api/file.js